


















































import Vue from "vue";
import { Component, Watch, Emit, Prop } from "vue-property-decorator";
import './codecheck.less';

import {Validations} from 'vuelidate-property-decorators';
import { required,email } from 'vuelidate/lib/validators';
import {submitForm} from '../../service/webclient/webclient';

import Simplemodal from '../simplemodal/simplemodal.vue';

import Login from '../login/login.vue';


@Component({
  components: {
      Login,
      Simplemodal
  }
})
export default class Codecheck extends Vue {

    private code;
    private texts= {
        code_not_exists_title: 'Sajnáljuk, Ön nem nyert.',
        code_not_exists_text: 'Köszönjük, hogy velünk játszott!',
        win_30_title: 'Gratulálunk!',
        win_30_text: 'Sikeres pályázatot nyújtott be. Nyereménye:<br><br><img src="/assets/images/ikea_desktop_header.png" class="img-fluid pb-2"><br><br>' +
            'Ajándéka átvételével kapcsolatban az elérhetőségein felvesszük Önnel a kapcsolatot!',
        win_100_title: 'Gratulálunk! Ön nyert.',
        win_100_text: '<br><br>Ön maximum 2,5 millió Ft összeghatárig visszanyerte Baumit hőszigetelő rendszere árát!<br><br>' + 'Az ajándék átvételével kapcsolatban az elérhetőségein felvesszük Önnel a kapcsolatot!<br><br>',
    };

    private modalData={
        title : 'Title',
        content: '',
        key: 'winnerModal'
    };

  codeSubmit(){
      let self = this;
      (this as any).$v.code.$touch();
      if(!(this as any).$v.code.$invalid){
        submitForm('#validate_code',{code:(this as any).code}).then((resp)=>{
            self.modalData.title=self.texts[resp.result+'_title'];
            self.modalData.content=self.texts[resp.result+'_text'];
          $('#'+self.modalData.key).modal('show');
        });
      }
  }

  @Validations()
    validations = {
        code: {required},
    }



}
